const serverAddress = 'https://weiyunkj.com/';
const CONFIG = {
  // serverAddress: 'http://localhost:3399',
  // serverAddress: 'https://91huajian.cn',
  serverAddress: serverAddress,
  smallpigAddress: 'https://smallpig.site'
};
export default CONFIG;
